import axios from '@/axios/api.request'

export const password = (data) => axios.request({
    url: '/system/user/password',
    data,
    method: 'post'
  })
export const list = (from) => axios.request({
    url: 'system/user/list',
    data: from,
    method: 'post'
  })
export const handover = (from) => axios.request({
  url: 'system/user/handover',
  data: from,
  method: 'post'
})
export const handoverList = (userId) => axios.request({
  url: 'system/user/handover/list',
  params: { userId },
  method: 'get'
})
export const save = (from) => axios.request({
    url: 'system/user/save',
    data: from,
    method: 'post'
  })
  export const saveDetail = (from) => axios.request({
    url: 'system/user/detail/save',
    data: from,
    method: 'post'
  })
export const saveRole = (from) => axios.request({
    url: 'system/userRole/save',
    data: from,
    method: 'post'
  })
  export const level = (from) => axios.request({
    url: 'system/user/level',
    data: from,
    method: 'post'
  })
export const getByMid = (from) => axios.request({
    url: '/system/user/getByMid',
    data: from,
    method: 'post'
  })

export const users = (from) => axios.request({
    url: '/system/user/users',
    data: from,
    method: 'post'
  })
export const getAuth = (id) => axios.request({
    url: '/system/user/auth',
    params: { id },
    method: 'get'
  })
export const syncUser = () => axios.request({
    url: 'system/user/sync',
    method: 'get'
  })